module.exports = __webpack_public_path__ + "img/hc_pro_eight_2.c398aab1.jpg";